import wgetMgr from "./wgetMgr";
import WidgetBase from "./WidgetBase";
import { Message } from "element-ui";

const addName = [
  "role",
  "post",
  "department",
  "corporate",
  "area",
  "dictionary",
  "selector",
  "user"
];

const callTransFn = (trans: string, result: any) => {
  const code = trans.replace("function", "window.transFn=function") as string;
  try {
    eval(code);

    const res = (window as any).transFn.call(this, result);
    return res;
  } catch (error) {
    console.log(error);
    Message.error("结果转换函数不合法");
  }
};

/**
 * 提供事件功能组件基类
 */
export class EventWidgetComponent extends WidgetBase {
  /**
   * 统一处理组件事件
   */
  handleEvent(data: any, isInit: boolean = false) {
    const suffix = this.widget.id.match(/:\w*/);
    const suffixId = suffix ? suffix[0] : "";

    /**
     * 联动刷新其他组件
     */
    if (!isInit && this.widget.events?.linkedList) {
      this.widget.events.linkedList.forEach((d) => {
        const target = wgetMgr.getWidgetById(d.id + suffixId) as App.LinkedWidgetComponent;
        (Array.isArray(target) ? target : [target]).forEach((i) => {
          if (i.refresh) {
            i.refresh({
              property: d.propertyName,
              type: d.propertyType,
              value: data
            });
          }
        });
      });
    }

    /**
     * 为其他组件设置值
     */
    if (this.widget.events?.puttedList) {
      const _this = this as unknown as App.PutAbleWidgetComponent;
      this.widget.events.puttedList.forEach((d) => {
        const target = wgetMgr.getWidgetById(d.id + suffixId) as App.PuttedWidgetComponent;
        (Array.isArray(target) ? target : [target]).forEach((i) => {
          if (i.setValue) {
            let value: any;
            if (
              _this.putModel &&
              Object.prototype.hasOwnProperty.call(_this.putModel, d.propertyName)
            ) {
              value = _this.putModel[d.propertyName];
            } else {
              value = data?.toString();
              if (
                d.propertyName === "custom"
              ) {
                const code = d.code.replace("function", "window.fn=function") as string;
                try {
                  eval(code);
                  const res = (window as any).fn.call(
                    this,
                    JSON.parse(JSON.stringify(data)),
                    JSON.parse(JSON.stringify(this.originData))
                  );
                  if (typeof res === "string") {
                    value = res;
                  } else if (typeof res === "object") {
                    value = typeof res.value === "string" ? res.value : undefined;

                    if (Object.prototype.hasOwnProperty.call(res, "readonly")) {
                      i.widget.readonly = res.readonly;
                    }

                    if (
                      !i.widget.readonly &&
                      Object.prototype.hasOwnProperty.call(res, "required")
                    ) {
                      i.widget.required = !!res.required;
                      this.rules[i.widget.property.propertyName][0].required = !!res.required;
                      if (!res.required) {
                        i.$nextTick(() => {
                          (i.$el as HTMLElement)
                            .querySelector(".is-error")
                            ?.classList.remove("is-error");
                        });
                      }
                    }

                    if (Object.prototype.hasOwnProperty.call(res, "visible")) {
                      i.widget.visible = res.visible;
                    }
                  } else {
                    this.$message.error("自定义代码返回值格式不正确");
                  }
                } catch (error) {
                  this.$message.error("自定义代码不是可执行函数");
                }
              }
            }

            if (isInit) return;

            if (d.propertyName !== "custom" && addName.includes(d.targetWidgetType)) {
              const pre = d.propertyName.match(/.*(?=(Id|Name))/i) || [];
              let id = _this.putModel?.[`${pre[0]}Id`];
              let name = _this.putModel?.[`${pre[0]}Name`];

              if (d.targetWidgetType === "user" && !name) {
                id = _this.putModel?.userId;
                name = _this.putModel?.realName;
              }
              if (pre && _this.putModel && id && name) {
                value = (d.propertyType ? `${d.propertyType}:` : "") + id + "," + name;
              } else {
                value = (d.propertyType ? `${d.propertyType}:` : "") + ",";
              }
            }

            value !== undefined && i.setValue(value);
          }
        });
      });
    }
  }

  /**
   * 组合运算
   */
  operateHandler() {
    try {
      const {
        advance: { operation },
        widgets
      } = JSON.parse(this.originData.formRenderData);

      const field = this.widget.property.propertyName;

      const isSubWidget = this.widget.isSubWidget;
      const parentWidgetVue: any = isSubWidget
        ? wgetMgr.getWidgetById(this.widget.parentWidgetId)
        : {};

      (operation as App.OperationItem[]).forEach(
        ({ config, target, direct }: App.OperationItem) => {
          if (isSubWidget) {
            const { widget: parentWidget } = parentWidgetVue;
            const [id, suffix] = this.widget.id.split(":");
            [id];
            const hasWidget = config.input.includes(
              `[${parentWidget.property.propertyName},${field}]`
            );
            if (hasWidget && target !== "auto") {
              const oc = JSON.parse(JSON.stringify(config));
              let cols = oc.input.join("");
              if (direct === "row") {
                const rowWidget = parentWidgetVue.widget.widgetList.find((i: any) =>
                  i[0].id.endsWith(suffix)
                );
                rowWidget.forEach((i: any) => {
                  const col = `${parentWidget.property.propertyName},${i.property.propertyName}`;
                  if (cols.includes(`[${col}]`)) {
                    const reg = new RegExp(`\\[${col}\\]`, "g");
                    cols = cols.replaceAll(reg, Number(i.value));
                  }
                });

                // console.log("🚀 ~ EventWidgetComponent ~ operateHandler ~ cols:", cols, rowWidget)
                let results = eval(cols);
                results =
                  oc.prefix + oc.trans ? callTransFn(oc.trans, results) : results + oc.suffix;
                const targetWidgetId = rowWidget.find(
                  (i: any) =>
                    `${parentWidget.property.propertyName},${i.property.propertyName}` === target
                ).id;

                const targetWidgetVue = wgetMgr.getWidgetById(targetWidgetId);
                (Array.isArray(targetWidgetVue) ? targetWidgetVue : [targetWidgetVue]).forEach(
                  (i: any) => i.setValue(results)
                );
              } else {
                let results: any = 0;
                const type: string = oc.input.splice(-1)[0];

                const targetWidgetVue: any = wgetMgr.getWidgetById(
                  widgets.find((i: any) => i.property.propertyName === target).id
                );
                if (type === "sum" || type === "avr") {
                  results = parentWidgetVue.widget.widgetList.reduce((p: any, c: any) => {
                    const v = c.find(
                      (i: any) => i.property.propertyName === this.widget.property.propertyName
                    ).value;
                    return (p += Number(v));
                  }, 0);

                  results =
                    type === "avr" ? results / parentWidgetVue.widget.widgetList.length : results;
                  oc.trans && (results = callTransFn(oc.trans, results));
                  targetWidgetVue.setValue(`${config.prefix}${results}${config.suffix}`);
                } else if (type === "max" || type === "min") {
                  results = Math[type](
                    ...parentWidgetVue.widget.widgetList.map(
                      (i: any) =>
                        i.find(
                          (j: any) => j.property.propertyName === this.widget.property.propertyName
                        ).value
                    )
                  );
                  oc.trans && (results = callTransFn(oc.trans, results));
                  targetWidgetVue.setValue(`${config.prefix}${results}${config.suffix}`);
                }
              }
            }
          } else {
            const hasWidget = config.input.includes(`[${field}]`);
            if (hasWidget) {
              let formula = config.input.join("");
              const fieldList = [...new Set(formula.match(/\[[a-zA-Z]*\]/g))];
              fieldList.forEach((j: string) => {
                const widget = this.model[field] === undefined;
                let val;
                if (widget) {
                  const results: App.OriginDataResults = this.originData.results;
                  val = results[j.slice(1, -1)] ? results[j.slice(1, -1)].value : 0;
                } else {
                  val = this.model[j.slice(1, -1)] || 0;
                }
                formula = formula.replaceAll(j, Number(val).toString());
              });
              // console.log(formula);
              let result = eval(formula);

              if (config.trans) {
                result = callTransFn(config.trans, result);
              }

              this.model[target] = config.prefix + result + config.suffix;
            }
          }
        }
      );
    } catch (error) {
      console.log("运算公式错误", error);
    }
  }
}
